var _PROGRESS_INDICATOR_T;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import { SIZE_NAMES, STYLES, STYLE_GRADIENT, STYLE_PROGRESS, TYPES, STYLE_CONFIG, CIRCULAR_SIZES, CIRCULAR_DETERMINATE_VIEWBOX, CIRCULAR_INDETERMINATE_VIEWBOX, TYPE_INDETERMINATE, TYPE_DETERMINATE } from './constants';
import { getStyleByProgress } from './utils';

var Indeterminate = function Indeterminate(_ref) {
  var containerStyle = _ref.containerStyle,
      gradientId = _ref.gradientId,
      stopColor1 = _ref.stopColor1,
      stopColor2 = _ref.stopColor2,
      stroke = _ref.stroke,
      strokeWidth = _ref.strokeWidth;
  return React.createElement("svg", {
    className: "eds-progress-indicator--circular eds-fx--rotate",
    viewBox: CIRCULAR_INDETERMINATE_VIEWBOX,
    style: containerStyle,
    "aria-valuetext": gettext('In progress')
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    id: gradientId
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: stopColor1
  }), React.createElement("stop", {
    offset: "50%",
    stopColor: stopColor1
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: stopColor2,
    stopOpacity: "0"
  }))), React.createElement("path", {
    d: "M93.5,50C93.5,74,74,93.5,50,93.5S6.5,74,6.5,50S26,6.5,50,6.5",
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeLinecap: "round",
    shapeRendering: "geometricPrecision",
    fill: "none"
  }));
}; // Calculate the length of the svg path (stroke) based on the progress
// Then return a formatted stroke-dasharray


var _getProgressDashArray = function _getProgressDashArray(radius, progress) {
  // C = 2π * r - Thanks Archimedes of Syracuse!
  var circumference = 2 * Math.PI * radius;
  var portion = circumference / 100;
  var progressPortion = progress * portion;
  return "".concat(progressPortion, ",").concat(circumference);
};

var Determinate = function Determinate(_ref2) {
  var containerStyle = _ref2.containerStyle,
      style = _ref2.style,
      gradientId = _ref2.gradientId,
      stopColor1 = _ref2.stopColor1,
      stopColor2 = _ref2.stopColor2,
      railColor = _ref2.railColor,
      stroke = _ref2.stroke,
      strokeWidth = _ref2.strokeWidth,
      progress = _ref2.progress;
  var radius = 50;
  var center = 52;
  var strokeStyle = stopColor1;
  var railStrokeWidth = strokeWidth - 1;

  var strokeDasharray = _getProgressDashArray(radius, progress); // Use a linear gradient stroke


  if (style === STYLE_GRADIENT) {
    strokeStyle = stroke;
  }

  return React.createElement("svg", {
    className: "eds-progress-indicator--circular-determinate",
    viewBox: CIRCULAR_DETERMINATE_VIEWBOX,
    style: containerStyle,
    shapeRendering: "geometricPrecision",
    role: "progressbar",
    "aria-valuenow": progress,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }, React.createElement("defs", null, React.createElement("linearGradient", {
    id: gradientId
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: stopColor1
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: stopColor2
  }))), React.createElement("circle", {
    className: "eds-progress-indicator--circular-determinate__rail",
    cx: center,
    cy: center,
    r: radius,
    stroke: railColor,
    strokeWidth: railStrokeWidth,
    fill: "none"
  }), React.createElement("circle", {
    className: "eds-progress-indicator--circular-determinate__circle",
    cx: center,
    cy: center,
    r: radius,
    stroke: strokeStyle,
    strokeWidth: strokeWidth,
    strokeDasharray: strokeDasharray,
    strokeLinecap: "round",
    fill: "none"
  }));
};

var PROGRESS_INDICATOR_TYPE_MAP = (_PROGRESS_INDICATOR_T = {}, _defineProperty(_PROGRESS_INDICATOR_T, TYPE_INDETERMINATE, Indeterminate), _defineProperty(_PROGRESS_INDICATOR_T, TYPE_DETERMINATE, Determinate), _PROGRESS_INDICATOR_T);

var Circular =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Circular, _React$PureComponent);

  function Circular() {
    _classCallCheck(this, Circular);

    return _possibleConstructorReturn(this, _getPrototypeOf(Circular).apply(this, arguments));
  }

  _createClass(Circular, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          style = _this$props.style,
          type = _this$props.type,
          progress = _this$props.progress;

      var _ref3 = style === STYLE_PROGRESS ? getStyleByProgress(progress) : STYLE_CONFIG[style],
          stopColor1 = _ref3.stopColor1,
          stopColor2 = _ref3.stopColor2,
          railColor = _ref3.railColor;

      var _CIRCULAR_SIZES$size = CIRCULAR_SIZES[size],
          diameter = _CIRCULAR_SIZES$size.diameter,
          strokeWidth = _CIRCULAR_SIZES$size.strokeWidth;
      var containerStyle = {
        width: diameter,
        height: diameter
      };
      var gradientId = "stroke-".concat(size, "-").concat(style, "-").concat(type);
      var stroke = "url(#".concat(gradientId, ")");
      var Component = PROGRESS_INDICATOR_TYPE_MAP[type];
      return React.createElement(Component, {
        containerStyle: containerStyle,
        style: style,
        gradientId: gradientId,
        stopColor1: stopColor1,
        stopColor2: stopColor2,
        railColor: railColor,
        stroke: stroke,
        strokeWidth: strokeWidth,
        progress: progress
      });
    }
  }]);

  return Circular;
}(React.PureComponent);

_defineProperty(Circular, "propTypes", {
  /**
  * size and stroke of the loader
  * (small-thin, small-chunky, large-thin, large-chunky)
  */
  size: PropTypes.oneOf(SIZE_NAMES),

  /**
  * Type of indicator for the loader (indeterminate | determinate)
  */
  type: PropTypes.oneOf(TYPES),

  /**
  * Color of the loader (dark | light | gradient)
  */
  style: PropTypes.oneOf(STYLES),

  /**
  * Progress bar if the chosen Type is determinate
  */
  progress: PropTypes.number
});

export { Circular as default };